export enum ThemeNameEnum {
  V1 = 'V1',
  V2 = 'V2',
}

export type ThemeName = keyof typeof ThemeNameEnum;
